export default __webpack_public_path__ + "static/media/m4.a6178819.svg";